module.exports = __webpack_public_path__ + "img/auto-id.58053cbe.svg";